export enum TYPE_MEMBER {
  NON_MEMBER = '0',
  MEMBER = '1',
  ADMIN = '2',
}

export enum FORM_NAMES {
  NAME = 'user-name-sf',
  NICKNAME = 'user-nickname-sf',
  NUMBER = 'user-number-sf',
  ACCEPT = 'user-accept-sf',
}

export enum ALARM_INPUT {
  ACCEPT = 'accept',
  NAME = 'name',
  PHONE_NUMBER = 'phone',
}

export enum MODULE_NAME {
  CURATION = 'renderCuration',
  CALENDAR = 'renderCalendar',
  TOP_BANNER = 'renderTopBanner',
  SCHEDULE = 'renderSchedule',
  BROADCAST = 'renderBroadcast',
}

export enum TIME {
  SNACKBAR_DURATION = 3000,
}

export enum LINK_MOVE_TYPE {
  REDIRECT = 'redirect',
  REPLACE = 'replace',
  NEW_WINDOW = 'newWindow',
}
export enum THEME_TYPE {
  DEFAULT = 'theme',
  TYPE_B = 'themeB',
}

export const STORAGE_KEYS_PREFIX = 'sauce_collect_'

export enum CUSTOM_CLASS_NAME {
  HEADER = 'fx-collection-header',
  HEADER_PARTNER_LOGO = 'fx-collection-partner-logo',
  CONTENTS = 'fx-collection-contents',
  TOP_BANNER = 'fx-collection-top-banner',
  LIVE = 'fx-collection-live',
  LIVE_TITLE = 'fx-collection-live-title',
  LIVE_CONTENTS = 'fx-collection-live-contents',
  LIVE_CARD = 'fx-collection-live-card',
  LIVE_CARD_SKELETON = 'fx-collection-live-card-skeleton',
  SCHEDULE = 'fx-collection-schedule',
  SCHEDULE_TITLE = 'fx-collection-schedule-title',
  SCHEDULE_CONTENTS = 'fx-collection-schedule-contents',
  SCHEDULE_CARD = 'fx-collection-schedule-card',
  SCHEDULE_CARD_SKELETON = 'fx-collection-schedule-card-skeleton',
  CURATION_CATEGORY = 'fx-collection-curation-category',
  CURATION_CATEGORY_TITLE = 'fx-collection-curation-category-title',
  CURATION_CATEGORY_CONTENTS = 'fx-collection-curation-category-contents',
  CURATION_CATEGORY_BUTTON = 'fx-collection-curation-category-button',
  CURATION_CATEGORY_BUTTON_SKELETON = 'fx-collection-curation-category-button-skeleton',
  CURATION = 'fx-collection-curation',
  CURATION_TITLE = 'fx-collection-curation-title',
  CURATION_CONTENTS = 'fx-collection-curation-contents',
  CURATION_CARD = 'fx-collection-curation-card',
  CURATION_CARD_SKELETON = 'fx-collection-curation-card-skeleton',
}
